module.exports = __webpack_public_path__ + "media/images/flat_rate_camp_banner-9faed65de98c20f1d0f64e09e72667d4.png";